module.exports = __webpack_public_path__ + "img/1547102639.a4388969.jpg";